import { useNavigate } from 'react-router-dom';
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
} from '@/components/ui/table';
import { StatusBadge } from '@/components/status-badge';
import { formatAmount, formatDate } from '@/lib/utils';
import type { PaymentResponse } from '@/lib/api';

interface PaymentTableProps {
  payments: PaymentResponse[];
  compact?: boolean;
}

export function PaymentTable({ payments, compact = false }: PaymentTableProps) {
  const navigate = useNavigate();

  if (payments.length === 0) {
    return (
      <div className="flex items-center justify-center py-12 text-sm text-slate-400">
        No payments found.
      </div>
    );
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Bill Reference</TableHead>
          <TableHead>Bank</TableHead>
          <TableHead>Amount</TableHead>
          <TableHead>Status</TableHead>
          {!compact && <TableHead>Created</TableHead>}
          {!compact && <TableHead>Expires</TableHead>}
        </TableRow>
      </TableHeader>
      <TableBody>
        {payments.map((payment) => (
          <TableRow
            key={payment.id}
            className="cursor-pointer"
            onClick={() => navigate(`/payments/${payment.id}`)}
          >
            <TableCell className="font-mono text-xs">{payment.billReference}</TableCell>
            <TableCell>
              <span className="rounded bg-slate-100 px-2 py-0.5 text-xs font-semibold text-slate-700">
                {payment.bank}
              </span>
            </TableCell>
            <TableCell className="font-medium tabular-nums">
              {formatAmount(payment.amountCents)}
            </TableCell>
            <TableCell>
              <StatusBadge status={payment.status} />
            </TableCell>
            {!compact && (
              <TableCell className="text-xs text-slate-500">{formatDate(payment.createdAt)}</TableCell>
            )}
            {!compact && (
              <TableCell className="text-xs text-slate-500">
                {payment.status === 'PENDING' ? formatDate(payment.qrExpiresAt) : '—'}
              </TableCell>
            )}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
